<div class="pl-pane__container--horizontal">
  <header class="pl-page-header pl-pane--shrink">
    <h1 class="pl-heading--xlarge">Open Registration</h1>
  </header>
</div>
